<div class="mf-menu-footer">
    <div class="text-center">
        <mds-app-info [classList]="'mf-version small'" [type]="'version'"></mds-app-info>
        <mds-app-info [classList]="'branch-name'" [type]="'branch'"></mds-app-info>
    </div>
</div>
